let language = {
    STORE_PRODUCT_SETTING_NAVIGATION_PRODUCT_NAME: "产品",
    STORE_PRODUCT_SETTING_NAVIGATION_DESIGN_NAME: "设计",
    STORE_PRODUCT_SETTING_NAVIGATION_MOCKUP_NAME: "模型",
    STORE_PRODUCT_SETTING_NAVIGATION_INFO_NAME: "信息",
    STORE_PRODUCT_SETTING_NAVIGATION_PRICING_NAME: "定价",
    STORE_PRODUCT_SETTING_NAVIGATION_BINDING_NAME: "绑定",
    STORE_PRODUCT_SETTING_NAVIGATION_PHOTO_LIB_NAME: "素材库",
    STORE_PRODUCT_SETTING_NAVIGATION_DESIGN_FIX_NAME: "固定设计",
    STORE_PRODUCT_SETTING_NAVIGATION_DESIGN_RANDOM_NAME: "随机设计",
};

export { language }
